import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { initializeFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// Initialize Firestore with settings to help avoid QUIC protocol errors
// Using initializeFirestore allows us to configure settings before first use
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  // This helps avoid QUIC protocol errors by forcing long polling transport
});

export const auth = getAuth(app);

// Initialize Firebase Functions with the correct region
const functionRegion = process.env.REACT_APP_FIREBASE_FUNCTION_REGION;
export const functions = getFunctions(app, functionRegion); 